import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { User, Sparkles } from 'lucide-react';

interface ChatMessageProps {
  role: 'user' | 'assistant';
  content: string;
  isStreaming?: boolean;
}

export function ChatMessage({ role, content, isStreaming }: ChatMessageProps) {
  const isUser = role === 'user';

  return (
    <div className={`flex gap-3 ${isUser ? 'justify-end' : ''}`}>
      {!isUser && (
        <div className="shrink-0 w-7 h-7 rounded-lg flex items-center justify-center bg-chart-teal/10">
          <Sparkles size={14} className="text-chart-teal" />
        </div>
      )}

      <div className={`max-w-[85%] rounded-xl px-4 py-3 text-sm leading-relaxed ${
        isUser
          ? 'bg-chart-teal text-white rounded-br-sm'
          : 'rounded-bl-sm'
      }`} style={!isUser ? { backgroundColor: 'var(--color-surface)', color: 'var(--color-text-primary)' } : undefined}>
        {isUser ? (
          <p>{content}</p>
        ) : (
          <div className="prose-sm max-w-none [&_p]:mb-2 [&_p:last-child]:mb-0 [&_ul]:mb-2 [&_ol]:mb-2 [&_li]:mb-0.5 [&_table]:text-xs [&_th]:px-2 [&_th]:py-1 [&_td]:px-2 [&_td]:py-1 [&_strong]:font-semibold [&_code]:text-xs [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded [&_code]:font-mono"
            style={{ color: 'var(--color-text-primary)' }}>
            <Markdown remarkPlugins={[remarkGfm]}>{content || (isStreaming ? '...' : '')}</Markdown>
          </div>
        )}
        {isStreaming && content && (
          <span className="inline-block w-1.5 h-4 bg-chart-teal/60 animate-pulse ml-0.5 align-text-bottom rounded-sm" />
        )}
      </div>

      {isUser && (
        <div className="shrink-0 w-7 h-7 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'var(--color-surface)' }}>
          <User size={14} className="text-secondary" />
        </div>
      )}
    </div>
  );
}
